var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      attrs: {
        "view-slug": "icons-landing",
        "is-showing-v7-prerelease-notice": true,
      },
    },
    [
      _c("wa-page-header", { attrs: { slot: "header" }, slot: "header" }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "app-content",
          attrs: { slot: "content", role: "main" },
          slot: "content",
        },
        [
          _c(
            "div",
            {
              staticClass: "padding-top-2xl",
              staticStyle: { background: "var(--white)" },
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c("icons-header", {
                    attrs: { "selected-tab": _vm.selectedTab },
                    on: { "tab-change": _vm.setSelectedTab },
                  }),
                  _vm._v(" "),
                  _c("icons-features", {
                    attrs: { features: _vm.shortTermFeatures },
                  }),
                  _vm._v(" "),
                  _c("icons-features-long-term", {
                    attrs: { features: _vm.longTermFeatures },
                  }),
                  _vm._v(" "),
                  _c("icons-controls", {
                    attrs: { "selected-tab": _vm.selectedTab },
                    on: {
                      "tab-change": _vm.setSelectedTab,
                      "release-change": _vm.setRelease,
                      "all-versions-selected": _vm.navigateToVersions,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "transition-group",
            {
              staticClass: "container padding-top-4xl padding-bottom-6xl",
              attrs: {
                name: "tab-transition",
                tag: "div",
                "enter-active-class":
                  "animate__animated animate__faster animate__fadeIn",
              },
            },
            [
              _vm.isOlderVersion
                ? _c("wa-old-version-alert", {
                    key: "old-version-alert",
                    staticClass: "margin-bottom-3xl",
                    attrs: { subject: "icons" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedTab === "packs"
                ? _c("icons-packs", {
                    key: "packs",
                    staticClass: "tab-content",
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedTab === "categories"
                ? _c("icons-categories", {
                    key: "categories",
                    staticClass: "tab-content",
                    attrs: { release: _vm.release },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("wa-page-footer", { attrs: { slot: "footer" }, slot: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }